import {
  ReferenceMode,
  TabKey
} from 'containers/SubSidebar/AIVideoContent/consts'
import { IAIVideoState } from 'store/types/aiVideo'
import { IAIVideoGenerationParams } from 'types/aiVideo'

const getDefaultGenerationParams = (): IAIVideoGenerationParams => ({
  referenceMedias: undefined,
  selectedModel: null,
  duration: 0,
  aspectRatio: null,
  quality: 0,
  prompt: '',
  targetMediaItemId: null,
  aiImageId: null,
  isConsistencyEnabled: true,
  smartPrompt: '',
  // Real default is applied by `getAIVideoModels` once the user tier is known
  // (off for free, on for paid; a saved choice wins).
  isFastTrack: false,
  refImageSelectedStyleId: undefined
})

export const getInitialState = (): IAIVideoState => ({
  referenceMode: ReferenceMode.FRAMES,
  generationParams: getDefaultGenerationParams(),
  defaultGenerationSettings: null,
  aiVideoHistory: {
    videos: [],
    isLoading: false,
    isDataInitiallyLoaded: false,
    totalCount: 0,
    rawOffset: 0,
    isScopedToCurrentProject: true
  },
  isLoadingTabData: false,
  isModelsFetched: false,
  isRequestingGeneration: false,
  aiVideoModels: [],
  videoGenerationCost: 0,
  activeTab: TabKey.GENERATE,
  versionHistory: {
    items: [],
    isLoading: false,
    isLoaded: false
  },
  showVersionHistoryTab: false,
  hasUserSelectedImageAspectRatio: false,
  isPowerModeRequiredPopupOpen: false
})
